/** One definition of the table's columns so the header and rows line up. On
 * narrow screens every cell stacks. */
export const REPORT_TABLE_COLUMNS =
  "grid-cols-1 sm:grid-cols-[minmax(0,2.2fr)_9.5rem_7rem_minmax(0,1.3fr)_minmax(0,1.6fr)_1rem]";
